import styled from "styled-components";

export const BillingTableDiv = styled.div`
  width: 100%;
  height: 100%;
  table {
    thead {
      background-color: #E4E5F7;
      th {
        padding: 10px 15px;
        font-size: 14px;
        color: #1F1F52;
        text-align: left;
        border: 1.55px solid #FFFFFF;
      }
    }
    tbody {
      tr {
        background-color: #FAFAFC ;
        td {
          border: 1.55px solid #FFFFFF;
          padding: 24px 15px;
          font-size: 14px;
          color: #1F1F52;
        }
      }
    }
  }
`;

